import { BaseApiService } from '@/services/base-service';
import { AlfaApiLoanApplicationStatuses } from '@/modules/alfa-api-loan-application-statuses/types';
import { Response } from '@/types';

export class AlfaApiLoanApplicationStatusService extends BaseApiService {
  private readonly base_path = 'alfa-api-loan-application-statuses';

  async get() {
    const response = await this.http_client.get<Response<AlfaApiLoanApplicationStatuses.AlfaApiLoanApplicationStatus[]>>(
      this.base_path,
    );

    return response.data.data;
  }
}
